import { Text } from '@cash-me/react-components'
import styled from 'styled-components'

import { theme } from 'styles/theme'

const { media, space } = theme

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${space['spacing-xs']};

  @media (${media.tablet}) {
    flex-direction: row;
  }
`

export const Warning = styled(Text)`
  white-space: pre-wrap;
  text-align: center;

  @media (${media.tablet}) {
    white-space: inherit;
    text-align: left;
  }
`
